import { createFileRoute } from '@tanstack/react-router'
import TransactionErrorReportList from 'Royalty/components/Reports/ErrorReport/TransactionErrorReportList'

export const Route = createFileRoute('/royalty/errorlist/transactions')({
    component: TransactionErrorReportList,
})
